import React from 'react';
import { PropTypes } from 'prop-types';
import colors from '@general/colors';
import { useScreenSmDown, useScreenMinMd } from '@hooks/useResponsive';

const getIconDesktop = isActive => {
    const fill = isActive ? colors.primary : '#D3D0D5';
    const stroke = isActive ? '#fff' : '#000';

    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="19.6923" cy="20" r="19.6923" fill={fill} />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20 11.8077C18.0365 11.8077 16.5 13.293 16.5 15.0577V15.8077C16.5 16.7095 16.8954 17.7239 17.5554 18.5136C18.2147 19.3024 19.0854 19.8077 20 19.8077C20.9146 19.8077 21.7853 19.3024 22.4446 18.5136C23.1046 17.7239 23.5 16.7095 23.5 15.8077V15.0577C23.5 13.293 21.9635 11.8077 20 11.8077ZM15.5 15.0577C15.5 12.6809 17.5459 10.8077 20 10.8077C22.4541 10.8077 24.5 12.6809 24.5 15.0577V15.8077C24.5 16.9766 23.9998 18.2122 23.212 19.1549C22.4235 20.0983 21.2942 20.8077 20 20.8077C18.7058 20.8077 17.5765 20.0983 16.788 19.1549C16.0002 18.2122 15.5 16.9766 15.5 15.8077V15.0577Z"
                fill={stroke}
            />

            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.7337 20.3054C19.2351 19.9719 21.7714 19.9974 24.2656 20.3811L24.5322 20.4221C26.2396 20.6848 27.5 22.1539 27.5 23.8814V27.3077H12.5V23.9342C12.5 22.18 13.7986 20.6967 15.5374 20.4649L16.7337 20.3054ZM24.1135 21.3695C21.7134 21.0002 19.2729 20.9757 16.8659 21.2966L15.6696 21.4561C14.4276 21.6217 13.5 22.6812 13.5 23.9342V26.3077H26.5V23.8814C26.5 22.6475 25.5997 21.5981 24.3801 21.4105L24.1135 21.3695Z"
                fill={stroke}
            />
        </svg>
    );
};

const getIconMobile = isActive => {
    const stroke = isActive ? '#246EFF' : '#1A1A1A';

    return (
        <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 1.80768C6.03645 1.80768 4.5 3.29298 4.5 5.05768V5.80768C4.5 6.70948 4.89541 7.72394 5.55535 8.51357C6.21466 9.30244 7.08539 9.80768 8 9.80768C8.91462 9.80768 9.78534 9.30244 10.4446 8.51357C11.1046 7.72394 11.5 6.70948 11.5 5.80768V5.05768C11.5 3.29298 9.96355 1.80768 8 1.80768ZM3.5 5.05768C3.5 2.68088 5.54595 0.807678 8 0.807678C10.4541 0.807678 12.5 2.68088 12.5 5.05768V5.80768C12.5 6.97663 11.9998 8.21216 11.212 9.15485C10.4235 10.0983 9.29419 10.8077 8 10.8077C6.70582 10.8077 5.57654 10.0983 4.78805 9.15485C4.00019 8.21216 3.5 6.97663 3.5 5.80768V5.05768Z"
                fill={stroke}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.73372 10.3054C7.23513 9.97188 9.77136 9.99736 12.2656 10.3811L12.5322 10.4221C14.2396 10.6848 15.5 12.1539 15.5 13.8814V17.3077H0.5V13.9342C0.5 12.18 1.7986 10.6967 3.53743 10.4649L4.73372 10.3054ZM12.1135 11.3695C9.71343 11.0002 7.2729 10.9757 4.86588 11.2966L3.66959 11.4561C2.42757 11.6217 1.5 12.6812 1.5 13.9342V16.3077H14.5V13.8814C14.5 12.6475 13.5997 11.5981 12.3801 11.4105L12.1135 11.3695Z"
                fill={stroke}
            />
        </svg>
    );
};

const MenuTrustees = ({ isActive = false }) => {
    const isScreenSmDown = useScreenSmDown();
    const isScreenMinMd = useScreenMinMd();

    return (
        <>
            {isScreenSmDown && getIconMobile(isActive)}
            {isScreenMinMd && getIconDesktop(isActive)}
        </>
    );
};

MenuTrustees.propTypes = {
    isActive: PropTypes.bool,
};

export default MenuTrustees;
